var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChallenge = function SvgChallenge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 677",
    d: "M38.0769 37L27.7564 15.5513M38.0769 37H4.87179M38.0769 37H40.9487M27.7564 15.5513L19.3205 27.9359L13.4872 23.4487L4.87179 37M27.7564 15.5513V7.29487M4.87179 37H2M27.7564 7.29487V2H37.1795V7.29487H27.7564Z",
    stroke: "#4239FB",
    strokeWidth: 2.21198,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChallenge);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDMiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCA0MyAzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlZlY3RvciA2NzciIGQ9Ik0zOC4wNzY5IDM3TDI3Ljc1NjQgMTUuNTUxM00zOC4wNzY5IDM3SDQuODcxNzlNMzguMDc2OSAzN0g0MC45NDg3TTI3Ljc1NjQgMTUuNTUxM0wxOS4zMjA1IDI3LjkzNTlMMTMuNDg3MiAyMy40NDg3TDQuODcxNzkgMzdNMjcuNzU2NCAxNS41NTEzVjcuMjk0ODdNNC44NzE3OSAzN0gyTTI3Ljc1NjQgNy4yOTQ4N1YySDM3LjE3OTVWNy4yOTQ4N0gyNy43NTY0WiIgc3Ryb2tlPSIjNDIzOUZCIiBzdHJva2Utd2lkdGg9IjIuMjExOTgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";